import { Controller } from 'react-hook-form';
import SelectAdvertiser from '@/components/SelectAdvertiser';
import SelectCategory from '@/components/SelectCategory';
import { Field, FieldLabel } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

// const INTERNAL_PAGES = [
//     { value: 'Telemedicina', label: 'Telemedicina Eurobem' },
//     { value: 'Telepsicologia', label: 'Telepsicologia Eurobem' },
//     { value: 'Seguro', label: 'Seguro Eurobem' },
// ];

export default function ClubLinkDestinationFields({ control, setValue, watch, includeEmptyOption = false }) {
    const type = watch('type');

    const typeOptions = [
        ...(includeEmptyOption ? [{ value: '_none', label: 'Nenhum' }] : []),
        { value: 'link', label: 'Link/Url' },
        { value: 'category', label: 'Categoria' },
        { value: 'advertiser', label: 'Anunciante' },
        // { value: 'internal', label: 'Outros' },
    ];
    const typeItems = Object.fromEntries(typeOptions.map(option => [option.value, option.label]));

    return (
        <div className="flex flex-col gap-4">
            <Field>
                <FieldLabel>Destino</FieldLabel>
                <Controller
                    name="type"
                    control={control}
                    render={({ field }) => (
                        <Select
                            items={typeItems}
                            value={field.value || (includeEmptyOption ? '_none' : 'link')}
                            onValueChange={value => {
                                const next = value === '_none' ? '' : value;
                                field.onChange(next);
                                if (next === 'link') {
                                    setValue('link', 'https://', { shouldDirty: true });
                                } else {
                                    setValue('link', '', { shouldDirty: true });
                                }
                            }}
                        >
                            <SelectTrigger className="w-full">
                                <SelectValue placeholder="Selecione o destino" />
                            </SelectTrigger>
                            <SelectContent>
                                {typeOptions.map(option => (
                                    <SelectItem key={option.value} value={option.value}>
                                        {option.label}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    )}
                />
            </Field>

            {type === 'link' ? (
                <Field>
                    <FieldLabel htmlFor="destination-link">Link</FieldLabel>
                    <Controller
                        name="link"
                        control={control}
                        render={({ field }) => (
                            <Input id="destination-link" {...field} value={field.value ?? ''} />
                        )}
                    />
                </Field>
            ) : null}

            {type === 'category' ? (
                <SelectCategory
                    label="Selecione a categoria"
                    value={watch('link')}
                    name="link"
                    onChange={setValue}
                />
            ) : null}

            {type === 'advertiser' ? (
                <SelectAdvertiser
                    label="Selecione o anunciante"
                    value={watch('link')}
                    name="link"
                    onChange={setValue}
                />
            ) : null}

            {/* {type === 'internal' ? (
                <Field>
                    <FieldLabel>Página</FieldLabel>
                    <Controller
                        name="link"
                        control={control}
                        render={({ field }) => (
                            <Select value={field.value || undefined} onValueChange={field.onChange}>
                                <SelectTrigger className="w-full">
                                    <SelectValue placeholder="Selecione um item" />
                                </SelectTrigger>
                                <SelectContent>
                                    {INTERNAL_PAGES.map(page => (
                                        <SelectItem key={page.value} value={page.value}>
                                            {page.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        )}
                    />
                </Field>
            ) : null} */}
        </div>
    );
}
